(() => {
  const popup = document.querySelector('[data-liora-intent-popup]');
  if (!popup) return;
  const storageKey = 'liora.intent.popup.seen';
  const submittedKey = 'liora.intent.popup.submitted';
  const open = () => { popup.hidden = false; document.documentElement.classList.add('liora-intent-open'); popup.querySelector('[data-liora-intent]')?.focus(); };
  const close = () => { popup.hidden = true; document.documentElement.classList.remove('liora-intent-open'); sessionStorage.setItem(storageKey, '1'); };
  const emailStep = popup.querySelector('[data-liora-intent-email-step]');
  const choiceStep = popup.querySelector('[data-liora-intent-choice-step]');
  const emailInput = popup.querySelector('#liora-intent-email');
  const intentTags = popup.querySelector('[data-liora-intent-tags]');
  const stepItems = [...popup.querySelectorAll('[data-liora-intent-step]')];
  const customerPosted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  const setEmailStep = () => {
    choiceStep.hidden = true;
    emailStep.hidden = false;
    stepItems.forEach((item) => item.classList.toggle('is-active', item.dataset.lioraIntentStep === '2'));
    popup.classList.add('is-email-step');
    emailInput?.focus();
  };
  if (customerPosted) {
    localStorage.setItem(submittedKey, '1');
    sessionStorage.setItem(storageKey, '1');
  }
  if (!sessionStorage.getItem(storageKey) && !localStorage.getItem(submittedKey)) window.setTimeout(open, 1400);
  popup.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-liora-intent]');
    if (choice) {
      const value = choice.dataset.lioraIntent;
      localStorage.setItem('liora.intent', value);
      document.cookie = `liora.intent=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'liora_intent_selected', liora_intent: value });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { liora_intent: value } }) }).catch(() => {});
      if (value === 'geen-korting') {
        close();
        return;
      }
      intentTags.value = `liora-intent,liora-intent-${value}`;
      sessionStorage.setItem(storageKey, '1');
      setEmailStep();
    } else if (event.target.closest('[data-liora-intent-close]')) close();
  });
  popup.querySelector('form')?.addEventListener('submit', () => {
    localStorage.setItem(submittedKey, '1');
    sessionStorage.setItem(storageKey, '1');
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
})();
